import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { BaseApiEndpointService } from './base-api-endpoint.service';
import { FootprintsEndpoints } from './models/footprints-endpoint.model';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class FootprintsApiEndpointService extends BaseApiEndpointService {
  constructor(store: Store) {
    super(store, 'footprints');
  }

  getFundableProjectsUrl(
    partnerCode: string,
    countryCodes: string[],
    maxProjects: number = 3
  ): string {
    const queryParams = new HttpParams({
      fromObject: {
        maxProjects,
        countryCodes,
      },
    });

    return this.constructUrl(
      FootprintsEndpoints.FundableProjects(partnerCode),
      queryParams
    );
  }
}
